import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AgGrid, gridConstants as gc } from '../../AgGrid';
import classnames from 'classnames';

// SERVICES
import { getAllClientUsers } from '../../../services';

const styles = theme => ({});

export const ClientUsersGrid = withStyles(styles)(props => {
  const [gridData, setGridData] = useState(null);

  const columnDefinitions = [
    { headerName: 'Client', field: 'clientName' },
    { headerName: 'Email', field: 'email' },
    { headerName: 'First Name', field: 'fname' },
    { headerName: 'Last Name', field: 'lname' },
    { headerName: 'Title', field: 'title' },
    { headerName: 'Company', field: 'company' },
  ];

  const gridOptions = {};

  const getAllClientUsersAsync = async () => {
    try {
      const data = await getAllClientUsers();
      setGridData(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllClientUsersAsync();
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <AgGrid
        gridData={gridData}
        gridOptions={gridOptions}
        columnDefs={columnDefinitions}
        showCreateButton={true}
        redirectOnClick={true}
      />
    </div>
  );
});
